module.exports = __webpack_public_path__ + "images/Anaplan-4ad0aa.png";